var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000.36 299.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 943.79,
    y1: -29.9,
    x2: 988.49,
    y2: 283.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.28,299.93q-65.58,0-108.93-42.84T0,149.87Q0,86.09,43.25,43.05T151.07,0q57.33,0,94.65,29.27t46.77,67.49L225.7,113.25q-5.83-19.71-25.95-34.39T151.48,64.17q-36.61,0-59,24.74T70,149.46q0,35.41,22.64,60.75t58.84,25.35q28.35,0,48.38-14.18t25.84-33.9l66.79,16.9q-9.45,37.83-46.57,66.69T152.28,299.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.36,5.63h69.2V174.21q0,56.92-33.69,91.32t-94.25,34.4q-60.94,0-94.54-34.4t-33.6-91.32V5.63h69.2V173q0,28.77,15,46.47t43.85,17.7q28.86,0,43.85-17.7t15-46.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.47,294.1l-61.36-94.75H696.63V294.1H629V5.63H773.27q45.66,0,73.93,29.47T875.46,103A94.44,94.44,0,0,1,860,155.3q-15.5,23.94-43.45,35.4l69.6,103.4ZM696.63,66.79v72.82h71.61q17.7,0,29.27-10.66T809.08,103q0-14.9-11.17-25.55a37.47,37.47,0,0,0-26.85-10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.91,294.1V120.52h69.2V294.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M918.91,71V5.32h69.2V71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.27,130.15v34.2q0,59.34-40.43,97.46t-106.21,38.12q-67.2,0-111.24-43.05T1026.33,150q0-63.87,43.65-106.92T1178.21,0q52.3,0,89.21,25.55t51.4,63.77l-63.57,18.1Q1232.52,64.18,1179,64.17q-36.62,0-60,24.74t-23.44,60.55q0,35.82,24,61.36t67.29,25.55q29.16,0,47.17-14t22.43-33.7l-75.64.4V130.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1607.49,5.63h65.17V294.1h-68.39v-169L1519.38,241l-84.49-115.87v169H1366.5V5.63h65l88.31,128.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1930,294.1,1909.84,239H1787.93l-20.32,55.12h-70.4L1803.82,5.63h89.92L2000.36,294.1ZM1809.66,179.24h78.25l-39-108Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkblue);
export default __webpack_public_path__ + "static/media/dark & blue.5b6db9192747888e5338ca497088ac3b.svg";
export { ForwardRef as ReactComponent };